import React from "react";

import { LayoutContext } from "App/common/hoc/Layout";
import { decodeHandler } from "utils";

function BackupPlanConflictPopup(props) {
  const { lState } = React.useContext(LayoutContext);
  return (
    <React.Fragment>
      <p>
        <b>{decodeHandler(lState.popup.params.conflict.planName)}</b> has
        conflicts with the following plans. By creating this plan the already
        applied plans will be disabled for the selected device(s). Do you want
        to proceed?
      </p>
      <div className="tabular_data_wrap listview_sec">
        <div className="table_inner_header">
          <ul className="table_container">
            <li className="table_header">
              <div className="col col1">
                <div className="wrap_header_sort">
                  <span className="header_title">Plan</span>
                </div>
              </div>
              <div className="col col2">
                <div className="wrap_header_sort">
                  <span className="header_title">Devices</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div className="table_content_body ">
          <ul className="table_container">
            {lState.popup.params.conflict.conflicts.map((con, i) => (
              <li className="table_data_row" key={i}>
                <div className="inner_data_row">
                  <div className="col col1">
                    <span title={decodeHandler(con.planName)}>
                      {decodeHandler(con.planName)}
                    </span>
                  </div>
                  <div className="col col2">
                    {decodeHandler(con.devices.join(", "))}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
}

export default BackupPlanConflictPopup;
